import { api } from "./api";

export const addDocumentApi = (params) => {
    return api.post(`/document/create`, JSON.stringify(params));
};
export const documentListApi = (params) => {
    return api.get(`/document/list`, { params });
};

export const documentEditApi = (params) => {
    return api.post(`/document/edit`, JSON.stringify(params));
};

export const documentDeleteApi = (params) => {
    return api.post(`/document/delete`, JSON.stringify(params));
};

export const documentViewApi = (params) => {
    return api.get(`/document/view`, { params: params });
};

export const documentstatusApi = (params) => {
    return api.post(`/document/change-status`, JSON.stringify(params));
};

export const uploadFileApi = (params) => {
    return api.post(`/document/upload`, params, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};

export const foldersDropDownApi = (params) => {
    return api.get(`/document/folder-list`, { params: params });
};

export const teamsDropDownApi = (params) => {
    return api.get(`/document/teams-list`, { params: params });
};

export const assignTeamApi = (params) => {
    return api.post(`/document/assign-team`, JSON.stringify(params));
};

export const assignUserApi = (params) => {
    return api.post(`/document/assign-user`, JSON.stringify(params));
};

export const usersDropDownApi = (params) => {
    return api.get(`/document/team-users`, { params: params });
};

export const documentSummaryApi = (params) => {
    return api.get(`/document/summarize`, { params: params });
};

export const translateSummaryApi = (params) => {
    return api.post(`/document/translate-summary`, JSON.stringify(params));
};
